import { h, Component } from 'preact';
import Store from 'store/store';
import Close from 'components/bolt/icons/close';
import Share from 'components/bolt/icons/share';
import Download from 'components/bolt/icons/download';
import ArrowDown from 'components/bolt/icons/arrowDown';
import HTML from 'components/core/html/html';
import { sortObjectByOrder, joinClasses } from 'utils/utils';
import { swipeDetect } from 'utils/bolt/swipeDetect';
import { linkOut } from 'utils/bolt/index';
import s from 'components/bolt/pressKit/pressKitGalleryOverlay.sss';

export default class PressKitGalleryOverlay extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fadeOut: false
		};

		this.onSwipe = this.onSwipe.bind(this);
		this.downloadImage = this.downloadImage.bind(this);
		this.shareImage = this.shareImage.bind(this);
		this.closeOverlay = this.closeOverlay.bind(this);
		this.pageData = {};
	}

	componentDidMount() {
		const activePage = this.props.store?.activePage;
		this.pageData = this.props.store?.appData?.pages[activePage].data;
	}

	componentDidUpdate(prevProps) {
		const activeSlide = this.props.store?.pressKit?.overlayOpen;
		const oldActiveSlide = prevProps.store?.pressKit?.overlayOpen;
		const isDesktop = this.props.store?.client?.dimensions?.width >= 1024;
		const activePage = this.props.store?.activePage;
		const oldActivePage = prevProps.store?.activePage;

		if (activeSlide && !oldActiveSlide && !isDesktop) {
			if (this.image) {
				this.swipeDetect = swipeDetect(this.image, this.onSwipe, () => {}, 'horizontal');
			}
		} else if (oldActiveSlide && !activeSlide && !isDesktop) {
			this.swipeDetect && this.swipeDetect.remove();
		}

		if (oldActivePage !== activePage) {
			this.pageData = this.props.store?.appData?.pages[activePage].data;
		}
	}

	onSwipe(direction) {
		if (direction === 'none') return;
		const assets = sortObjectByOrder(this.pageData?.assets || {}, (val, key) => ({ ...val, key }));
		const activeAsset = assets.findIndex(asset => asset.key === Store.get().pressKit?.overlayOpen);
		let newIndex = activeAsset + (direction === 'left' ? 1 : -1);
		if (newIndex < 0) {
			newIndex = assets.length - 1;
		} else if (newIndex >= assets.length) {
			newIndex = 0;
		}
		const newAsset = assets[newIndex];
		this.setState({ direction });
		this.updateActiveSlide(newAsset.key);
	}

	async closeOverlay() {
		this.setState({ fadeOut: true });
		await new Promise(resolve => setTimeout(resolve, 300));
		Store.emit('TOGGLE_PRESSKIT_OVERLAY', null);
		this.setState({ fadeOut: false });
	}

	updateActiveSlide(key) {
		Store.emit('TOGGLE_PRESSKIT_OVERLAY', key);
	}

	downloadImage() {
		const assets = this.pageData?.assets || {};
		const activeAsset = assets[Store.get().pressKit?.overlayOpen] || {};

		if (activeAsset.assetLink) {
			return linkOut(activeAsset.assetLink);
		}

		Store.emit('DOWNLOAD_PRESSKIT_IMAGE', activeAsset);
	}

	async shareImage() {
		const assets = this.pageData?.assets || {};
		const activeAsset = assets[Store.get().pressKit?.overlayOpen];

		Store.emit('SHARE_PRESSKIT_IMAGE', activeAsset);
	}

	renderGallery() {
		const assets = this.pageData?.assets || {};
		const activeAsset = assets[Store.get().pressKit?.overlayOpen] || {};
		const { preview, thumbnail, alt } = activeAsset;
		const hideArrowsMobile = this.pageData?.hideArrowsMobile;
		const isDesktop = this.props.store?.client?.isDesktopSize;

		return (
			<div class={s.gallery} ref={ref => this.image = ref}>
				<img class={s.preview} src={preview || thumbnail} alt={alt} />
				<div class={joinClasses(s.arrows, hideArrowsMobile && !isDesktop && s.hide)}>
					<ArrowDown
						class={joinClasses(s.arrow, s.left)}
						onClick={() => this.onSwipe('right')}
					/>
					<ArrowDown
						class={joinClasses(s.arrow, s.right)}
						onClick={() => this.onSwipe('left')}
					/>
				</div>
			</div>
		);
	}

	renderBreadcrumbs() {
		const assets = sortObjectByOrder(this.pageData?.assets || {}, (val, key) => ({ ...val, key }));
		const activeAsset = Store.get().pressKit?.overlayOpen;
		const { direction } = this.state;

		return (
			<div class={s.breadcrumbs}>
				{assets.map((asset, index) => (
					<div
						class={joinClasses(
							s.dot,
							asset.key === activeAsset && s.active,
							direction === 'right' ? s.goingLeft : s.goingRight,
							index === 0 && s.isFirst,
							index === (assets.length - 1) && s.isLast
						)}
						onClick={() => this.updateActiveSlide(asset.key)}
					/>
				))}
			</div>
		);
	}

	renderInfo() {
		const { assets = {}, categories = {} } = this.pageData;
		const activeAsset = assets[Store.get().pressKit?.overlayOpen] || {};
		const { category, label } = activeAsset;
		const categoryName = categories[category];

		return (
			<div class={joinClasses(s.info, 'small')}>
				<span>
					<HTML markdown tag="strong" class={s.categoryName}>{categoryName}</HTML>:
				</span>
				<HTML tag="span" markdown>{label}</HTML>
			</div>
		);
	}

	renderIcons() {
		const canShare = this.props.store?.pressKit?.canShareFile;
		const isDesktop = this.props.store?.client?.device === 'desktop';

		return (
			<div class={s.icons}>
				{(canShare && !isDesktop) && <Share class={s.icon} onClick={this.shareImage} />}
				<Download class={s.icon} onClick={this.downloadImage} />
			</div>
		);
	}

	render() {
		const store = Store.get();
		const activeAsset = store.pressKit?.overlayOpen;
		const { fadeOut } = this.state;
		const assets = this.pageData?.assets || {};
		if (!activeAsset || !assets[activeAsset]) {
			return <div />;
		}

		return (
			<div class={joinClasses(s.wrapper, fadeOut && s.fadeOut)}>
				<div class={s.container}>
					<Close class={s.close} onClick={this.closeOverlay} />
					{this.renderGallery()}
					{this.renderBreadcrumbs()}
					{this.renderIcons()}
					{this.renderInfo()}
				</div>
			</div>
		);
	}
}